import classNames from 'classnames';
import type Quill from 'quill/core';
import type { Delta } from 'quill/core';
import React from 'react';
import EditorToolbar from '../../editor/controls/toolbar/EditorToolbar';
import QuillComponent from '../../editor/QuillComponent';
import HoverContentPreview from '../HoverContentPreview';
import * as styles from './HistoricalPost.module.scss';

interface HistoricalPostProps {
  content: Delta;
  onBlotComponentsInitialLoad?: (quill: Quill) => void;
}

const HistoricalPost = ({
  content,
  onBlotComponentsInitialLoad,
}: HistoricalPostProps) => {
  return (
    <div className={styles.historicalPost}>
      <EditorToolbar.DisableBoundary>
        <HoverContentPreview>
          <QuillComponent
            containerClassName={styles.editorContainer}
            rootClassName={classNames(styles.editorRoot, 'post-editor')}
            namespace="history"
            onBlotComponentsInitialLoad={onBlotComponentsInitialLoad}
            content={content}
            readOnly
          />
        </HoverContentPreview>
      </EditorToolbar.DisableBoundary>
    </div>
  );
};

export default HistoricalPost;
